import { environmentRecoil } from '@/recoil/atoms/MobileRecoil/MobileRecoil';
import React from 'react';
import { useRecoilValue } from 'recoil';
import AppRoutes from './AppRoutes';
import MobileRoutes from './MobileRoutes';
import { Route, Routes } from 'react-router-dom';
import AppDownloadComponent from '@/pages/AppDownloadComponent';
import IosAppDownloadComponent from '@/pages/IosAppDownloadComponent';
import Error404 from '@/pages/Error404';
import AppRouter from './AppRouter';

function RoutesComponent() {
  const environmentS = useRecoilValue(environmentRecoil);
  return (
    <>
      {/* 페이지 라우터 */}
      {environmentS === 'app' ? <MobileRoutes /> : <AppRoutes />}
      {/* 별도 광고 페이지 */}
      {/* 앱 다운로드 페이지 */}
      <Routes>
        <Route path="/*" element={<AppRouter />} />
        <Route path="/app" element={<AppDownloadComponent />} />
        <Route path="/iapp" element={<IosAppDownloadComponent />} />
      </Routes>
    </>
  );
}

export default RoutesComponent;
